import { VolatilityConesProvider } from '../../../../providers/volatility-cones-provider';
import VolatilityConesWidget from './volatility-cones-widget';

import { IVolatilityConesProps } from './types';

const VolatilityConesWrapperProvider = (props: IVolatilityConesProps) => {
  return (
    <VolatilityConesProvider providerKey={props.providerKey}>
      <VolatilityConesWidget {...props} />
    </VolatilityConesProvider>
  );
};

export default VolatilityConesWrapperProvider;
